import { initForms } from './forms';

function setupProductionPlanFilter(form: HTMLFormElement): void {
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const action = form.getAttribute('action') || window.location.pathname;
    const actionUrl = new URL(action, window.location.origin);
    const formData = new FormData(form);
    const queryParams = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (typeof value === 'string' && value.trim() !== '') {
        queryParams.set(key, value);
      }
    }

    actionUrl.search = queryParams.toString();

    fetch(actionUrl.toString(), {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(async (response) => {
        if (response.redirected) {
          window.location.href = response.url;
          return null;
        }

        if (!response.ok) {
          throw new Error('Failed to load filtered production plan.');
        }

        return response.text();
      })
      .then((html) => {
        if (!html) {
          return;
        }

        const contentWrapper = document.querySelector<HTMLElement>('.js-content');
        if (!contentWrapper) {
          return;
        }

        contentWrapper.innerHTML = html;
        initForms(contentWrapper);

        const productionPlanBody =
          contentWrapper.querySelector<HTMLElement>('#production-plan-body');
        const queryString = productionPlanBody?.dataset.productionPlanQueryString;

        if (queryString) {
          const newUrl = `${window.location.pathname}${queryString}`;
          window.history.pushState({}, '', newUrl);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Production plan filter fetch error:', error);
      });
  });
}

export function initProductionPlanFilter(): void {
  const form = document.querySelector<HTMLFormElement>('.js-production-plan-filter');
  if (!form) {
    return;
  }

  setupProductionPlanFilter(form);
}
